import React, { useEffect, useState } from "react";
import { getUsers, getAttendance, updateAttendance } from "./utils";
import { Link } from "react-router-dom";

function Attendance() {
  const [employees, setEmployees] = useState([]);
  const [attendanceLogs, setAttendanceLogs] = useState([]);
  const [holidays, setHolidays] = useState([]);

  const [selectedMonth, setSelectedMonth] = useState(
    new Date().getMonth() + 1
  );

  const [attendanceData, setAttendanceData] = useState([]);
  const [currentMonthDays, setCurrentMonthDays] = useState(30);

  // ✅ Load Data
  useEffect(() => {
    const users = getUsers().map((u, i) => ({
      id: i + 1,
      name: u.name,
    }));

    setEmployees(users);
    setAttendanceLogs(getAttendance());

    // ✅ Load holidays
    const holidayData =
      JSON.parse(localStorage.getItem("holidays")) || [];
    setHolidays(holidayData);
    console.log(holidayData)
  }, []);

  // ✅ Update month days
  useEffect(() => {
    const year = new Date().getFullYear();
    const days = new Date(year, selectedMonth, 0).getDate();
    setCurrentMonthDays(days);
  }, [selectedMonth]);

  // ✅ Sunday check
  const isSunday = (day, month, year) => {
    return new Date(year, month - 1, day).getDay() === 0;
  };

  // ✅ Holiday check
  const getHoliday = (dateStr) => {
    return holidays.find((h) => h.date === dateStr);
  };

  // ✅ MAIN LOGIC
  const processAttendance = () => {
    const year = new Date().getFullYear();
    const days = new Date(year, selectedMonth, 0).getDate();

    const finalData = employees.map((emp, index) => {
      let records = [];
      let recordtime = [];

      let p = 0,
        a = 0,
        hf = 0,
        l = 0;

      for (let day = 1; day <= days; day++) {
        const dateObj = new Date(year, selectedMonth - 1, day);
        const dateStr = dateObj.toLocaleDateString("en-CA");

        const found = attendanceLogs.find(
          (log) =>
            log.name.toLowerCase() === emp.name.toLowerCase() &&
            log.date === dateStr
        );

        let status = "absent";
        let timer = "absent";

        const holiday = getHoliday(dateStr);

        // ✅ 1. Custom Holiday
        if (holiday) {
          status = "holiday";
          timer = holiday.status; // weeklyoff / festivals
        }

        // ✅ 2. Sunday Rule
        else if (isSunday(day, selectedMonth, year)) {
          const prevDate = new Date(
            year,
            selectedMonth - 1,
            day - 1
          ).toLocaleDateString("en-CA");

          const nextDate = new Date(
            year,
            selectedMonth - 1,
            day + 1
          ).toLocaleDateString("en-CA");

          const prevLog = attendanceLogs.find(
            (log) =>
              log.name.toLowerCase() === emp.name.toLowerCase() &&
              log.date === prevDate
          );

          const nextLog = attendanceLogs.find(
            (log) =>
              log.name.toLowerCase() === emp.name.toLowerCase() &&
              log.date === nextDate
          );

          const prevStatus =
            prevLog?.status?.toLowerCase() || "absent";
          const nextStatus =
            nextLog?.status?.toLowerCase() || "absent";

          // 🔥 Sandwich Rule
          if (prevStatus === "absent" && nextStatus === "absent") {
            status = "absent";
            timer = "sandwich_rule";
          } else {
            status = "holiday";
            timer = "sunday";
          }
        }

        // ✅ 3. Attendance Logs
        else if (found) {
          status = found.status
            ? found.status.toLowerCase()
            : "present";
          timer = found.time
            ? found.time.toLowerCase()
            : "manual";
        }

        // ✅ Stats
        if (status === "present") p++;
        if (status === "absent") a++;
        if (status === "half") hf++;
        if (status === "leave") l++;

        records.push(status);
        recordtime.push(timer);
      }

      return {
        empId: index + 1001,
        name: emp.name,
        records,
        recordtime,
        present: p,
        absent: a,
        half: hf,
        leave: l,
      };
    });

    setAttendanceData(finalData);
  };

  // ✅ Edit Attendance
  const handleEdit = (name, day) => {
    const year = new Date().getFullYear();
    const dateObj = new Date(year, selectedMonth - 1, day);
    const dateStr = dateObj.toLocaleDateString("en-CA");

    const newStatus = prompt(
      "Enter status: present / absent / leave / half"
    );
    if (!newStatus) return;

    let newTime = "absent";

    if (newStatus === "present" || newStatus === "half") {
      newTime =
        prompt("Enter time (HH:mm)") || "manual";
    }

    updateAttendance(name, dateStr, {
      status: newStatus.toLowerCase(),
      time: newTime,
    });

    setAttendanceLogs(getAttendance());
  };

  useEffect(() => {
    if (employees.length) {
      processAttendance();
    }
  }, [employees, attendanceLogs, selectedMonth, holidays]);

  // ✅ Icons
  const icons = {
    present: "✅",
    absent: "❌",
    holiday: "🌞",
    half: "🌓",
    leave: "📝",
  };

  // ✅ CSV Download
  function downloadCSV(data, filename) {
    const keys = [...new Set(data.flatMap((obj) => Object.keys(obj)))];

    const escape = (val) => {
      const str = (val ?? "").toString().replace(/"/g, '""');
      return /[",\n]/.test(str) ? `"${str}"` : str;
    };

    const csv = [
      keys.join(","),
      ...data.map((obj) =>
        keys.map((k) => escape(obj[k])).join(",")
      ),
    ].join("\n");

    const blob = new Blob([csv], { type: "text/csv" });
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    link.click();
  }

  // ✅ Export CSV
  const exportCSV = () => {
    const statusMap = {
      present: "P",
      absent: "A",
      holiday: "H",
      leave: "L",
      half: "HF",
      sandwich_rule: "S",
    };

    const csvData = attendanceData.map((emp) => {
      let row = { Name: emp.name };

      emp.records.forEach((r, i) => {
        row[`D-${i + 1}`] = statusMap[r] || r;
      });

      row["Present"] = emp.present;
      row["Leave"] = emp.leave;
      row["Absent"] = emp.absent;
      row["Half"] = emp.half;

      return row;
    });

    downloadCSV(
      csvData,
      `Attendance_${selectedMonth}.csv`
    );
  };

  return (
    <div style={{ padding: "20px" }}>
      <div className="table-div">
        <div className="table-header">
          <h2>📊 Attendance List</h2>

          <div>
            <Link to="/">
           <button style={{width:"max-content",border:"none",background:"none",fontSize:"20px",cursor:"pointer"}}>
          📌
      </button>
            </Link>

            <select
              value={selectedMonth}
              onChange={(e) =>
                setSelectedMonth(Number(e.target.value))
              }
              class="select"
            >
              {[...Array(12)].map((_, i) => (
                <option key={i} value={i + 1}>
                  {new Date(0, i).toLocaleString("en", {
                    month: "short",
                  })}
                </option>
              ))}
            </select>
  <Link to="/holiday">
           <button class="button" style={{width:"max-content",margin:'0px 10px'}}>
          Add Holiday
      </button>
            </Link>
            <button onClick={exportCSV} class="button" style={{width:"max-content"}}>
              📥 Excel Download
            </button>
          </div>
        </div>
<div className="table">
 <table border="1" cellPadding="5">
          <thead>
            <tr>
              <th>Sr</th>
              <th>Name</th>

              {[...Array(currentMonthDays)].map((_, i) => (
                <th key={i}>{i + 1}</th>
              ))}

              <th>P</th>
              <th>L</th>
              <th>A</th>
              <th>HF</th>
            </tr>
          </thead>

          <tbody>
            {attendanceData.map((emp) => (
              <tr key={emp.empId}>
                <td>{emp.empId}</td>
                <td>{emp.name}</td>

                {emp.records.map((r, i) => (
                  <td
                    key={i}
                    title={emp.recordtime[i]}
                    onClick={() =>
                      handleEdit(emp.name, i + 1)
                    }
                    style={{ cursor: "pointer" }}
                  >
                    {icons[r] || "❓"}
                    <br />
                    <small>{emp.recordtime[i]}</small>
                  </td>
                ))}

                <td>{emp.present}</td>
                <td>{emp.leave}</td>
                <td>{emp.absent}</td>
                <td>{emp.half}</td>
              </tr>
            ))}
          </tbody>
        </table>

</div>
       
      </div>
    </div>
  );
}

export default Attendance;